import { render } from "./ProduitTransfert.vue?vue&type=template&id=0d5f7158&ts=true"
import script from "./ProduitTransfert.vue?vue&type=script&lang=ts"
export * from "./ProduitTransfert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__